import { render, staticRenderFns } from "./UserManagement.vue?vue&type=template&id=7335dda6&scoped=true&"
import script from "./UserManagement.vue?vue&type=script&lang=ts&"
export * from "./UserManagement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7335dda6",
  null
  
)

export default component.exports